import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

setOptions({
  key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  v: "weekly",
});

export function loadMapsLibrary () {
  return importLibrary("maps");
}

export function loadMarkerLibrary () {
  return importLibrary("marker");
}
